import type { FormContext } from 'vee-validate';
import { ref, watch } from 'vue';

import { i18n } from '@/plugins/i18n';

// Why not `errors`: a form reset with `{ force: true }` registers `answers` as a field of its own,
// so vee-validate files every error under it (`answers`, not `answers.steps[0].choices`) and
// leaves it out of `errors` until a forced validation. A silent `validate()` still reports it.
// Only a message with a translation is shown: yup's default ones, such as a missing language on a
// choice (`answers.steps[0].choices[0].text.en is a required field`), are not keys.
export function useAnswersErrorKey(form: Pick<FormContext, 'values' | 'validate'>) {
  const answersErrorKey = ref<string | null>(null);

  watch(
    () => form.values.answers,
    async () => {
      const { results } = await form.validate({ mode: 'silent' });
      const messages = Object.entries(results)
        .filter(([path]) => path === 'answers' || path.startsWith('answers.'))
        .flatMap(([, result]) => result?.errors ?? []);
      answersErrorKey.value = messages.find((message) => i18n.global.te(message)) ?? null;
    },
    { deep: true, immediate: true },
  );

  return { answersErrorKey };
}
